import { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import {
  ContactCard,
  Header,
  Ribbon,
  Subtitle,
  Title,
  OrnDivider,
  Form,
  Row,
  Field,
  Label,
  Input,
  Textarea,
  Actions,
  SubmitBtn,
  ErrorMsg,
  SuccessMsg,
  Helper,
} from "./ContactFormStyles";

const CREATE_CONTACT_MESSAGE = gql`
  mutation CreateContactMessage(
    $name: String!
    $email: String
    $phone: String!
    $subject: String
    $message: String!
    $source_path: String
  ) {
    createContactMessage(
      name: $name
      email: $email
      phone: $phone
      subject: $subject
      message: $message
      source_path: $source_path
    ) {
      message
      id
    }
  }
`;

export default function ContactForm() {
  const [nume, setNume] = useState("");
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");
  const [subiect, setSubiect] = useState("");
  const [mesaj, setMesaj] = useState("");
  const [errors, setErrors] = useState({});
  const [ok, setOk] = useState(false);

  const [mutate, { loading: sending }] = useMutation(CREATE_CONTACT_MESSAGE);

  const validate = () => {
    const e = {};
    if (!nume.trim()) e.nume = "Completează numele.";
    if (!telefon.trim()) e.telefon = "Completează telefonul.";
    if (!mesaj.trim()) e.mesaj = "Completează mesajul.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    setOk(false);
    if (!validate()) return;

    try {
      await mutate({
        variables: {
          name: nume,
          email,
          phone: telefon,
          subject: subiect,
          message: mesaj,
        },
      });

      setOk(true);
      setNume("");
      setEmail("");
      setTelefon("");
      setSubiect("");
      setMesaj("");
    } catch (err) {
      setErrors({ submit: "A apărut o eroare. Încearcă din nou." });
    }
  };

  return (
    <ContactCard>
      <Header>
        <Subtitle>Ai o întrebare sau o idee?</Subtitle>
        <Title>Scrie-ne un mesaj</Title>
      </Header>

      <OrnDivider />

      <Form onSubmit={handleSubmit}>
        <Row>
          <Field>
            <Label>Nume*</Label>
            <Input
              value={nume}
              onChange={(e) => setNume(e.target.value)}
              placeholder="Numele complet"
            />
            {errors.nume && <ErrorMsg>{errors.nume}</ErrorMsg>}
          </Field>

          <Field>
            <Label>Email</Label>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ex: nume@email.com"
            />
          </Field>
        </Row>

        <Row>
          <Field>
            <Label>Mobil*</Label>
            <Input
              value={telefon}
              onChange={(e) => setTelefon(e.target.value)}
              placeholder="ex: 07xx xxx xxx"
            />
            <Helper>Preferăm telefonul pentru confirmări rapide.</Helper>
          </Field>

          <Field>
            <Label>Subiect</Label>
            <Input
              value={subiect}
              onChange={(e) => setSubiect(e.target.value)}
              placeholder="ex: Tort aniversar"
            />
          </Field>
        </Row>

        <Field>
          <Label>Mesaj*</Label>
          <Textarea
            value={mesaj}
            onChange={(e) => setMesaj(e.target.value)}
            placeholder="Cum te putem ajuta?"
          />
          {errors.mesaj && <ErrorMsg>{errors.mesaj}</ErrorMsg>}
        </Field>

        <Actions>
          <SubmitBtn type="submit" disabled={sending}>
            {sending ? "Se trimite..." : "Trimite →"}
          </SubmitBtn>
        </Actions>

        {ok && <SuccessMsg>Mulțumim! Revenim cât mai curând 🤍</SuccessMsg>}
      </Form>
    </ContactCard>
  );
}
